export function productInstanceKey(fulfillmentMethod, productInstance) {
    const customParamsKey = customParameterInstancesKey(productInstance.customParameterInstances);
    const commonModifiersKey = modifierInstancesKey(productInstance.commonModifierInstances);
    const partsKey = productInstancePartsKey(fulfillmentMethod, productInstance.parts);
    return `ProductInstance[${customParamsKey},${commonModifiersKey}][${partsKey}]`;
}
export function productInstancePartsKey(fulfillmentMethod, parts) {
    let result = [];
    switch (parts.type) {
        case "SinglePart":
            result.push(fulfillmentMethodKey(fulfillmentMethod));
            result.push(isSplitKey(false));
            result.push(productTypeIdKey(parts.part.productTypeId));
            result.push(modifierInstancesKey(parts.part.modifierInstances));
            break;
        case "Halves":
            result.push(fulfillmentMethodKey(fulfillmentMethod));
            result.push(isSplitKey(true));
            result.push(productTypeIdKey(parts.first.productTypeId));
            result.push(modifierInstancesKey(parts.first.modifierInstances));
            result.push(productTypeIdKey(parts.second.productTypeId));
            result.push(modifierInstancesKey(parts.second.modifierInstances));
    }
    return result.join(",");
}
function fulfillmentMethodKey(fulfillmentMethod) {
    return `fulfillmentMethod=${fulfillmentMethod}`;
}
function isSplitKey(isSplit) {
    var _a;
    return `splitToHalves=${(_a = isSplit.toString()) !== null && _a !== void 0 ? _a : "null"}`;
}
function productTypeIdKey(productTypeId) {
    return `productType_${productTypeId.toString()}`;
}
function customParameterInstancesKey(customParameterInstances) {
    return customParameterInstances.objects
        .map((instance) => { var _a, _b; return `parameter_${instance.typeId.toString()}=${(_b = (_a = instance.selectedChoice) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "null"}`; })
        .raw.join(":");
}
function modifierInstancesKey(modifierInstances) {
    return modifierInstances.objects
        .map((modifierInstance) => `modifier_${modifierInstance.typeId.toString()}->` +
        modifierInstance.selectedItems
            .map((modifierItemInstance) => `${modifierItemInstance.typeId.toString()}=${modifierItemInstance.quantity.toString()}`)
            .raw.join("|"))
        .raw.join(":");
}
